export default {
  path: "/SectionContent/ExecutiveSummary",
  name: "Executive Summary",
  htmlContent: "executive_summary.html",
  headings: [],
};
